<template>
  <div class="div-aside"> 
    <span v-if="user.permisos_modulos.paciente.agendar || user.permisos_modulos.paciente.agenda || user.permisos_modulos.paciente.pacientes" class="aside-title-span" :class="{'text-header' : namePath.includes('paciente_')}"><b-icon style="vertical-align: text-bottom;"  font-scale="1.3" icon="people-fill" aria-hidden="true"></b-icon> PACIENTES</span>
    <b-list-group>
      <b-list-group-item v-if="user.permisos_modulos.paciente.agendar" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/agendar" :active="namePath==='paciente_agendar'">Agendar</b-list-group-item>

      <b-list-group-item  v-if="user.permisos_modulos.paciente.agenda" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/agenda" :active="namePath==='paciente_agenda'">Agenda del día</b-list-group-item>

      <b-list-group-item  v-if="user.permisos_modulos.paciente.pacientes" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/pacientes" :active="namePath==='paciente_pacientes'">Listado de pacientes</b-list-group-item>

      
      <b-list-group-item  v-if="user.permisos_modulos.paciente.historial" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/historial" :active="namePath==='paciente_historial'">Historial pacientes</b-list-group-item>

      <b-list-group-item  v-if="user.permisos_modulos.paciente.registrar" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/registrar" :active="namePath==='paciente_registrar'">Registros anteriores</b-list-group-item>  
      
      <b-list-group-item  v-if="user.permisos_modulos.paciente.garantias" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/paciente/garantias" :active="namePath==='paciente_garantias'">Garantias</b-list-group-item>  

    </b-list-group>
 
    <span v-if="user.permisos_modulos.orden.pendientes || user.permisos_modulos.orden.registro || user.permisos_modulos.orden.antiguos" class="aside-title-span" :class="{'text-header' : namePath.includes('orden_') && !namePath.includes('garantias')}"><b-icon style="vertical-align: text-bottom;" icon="documents" font-scale="1.1" aria-hidden="true"></b-icon> ORDENES</span>
    <b-list-group>
      <b-list-group-item  v-if="user.permisos_modulos.orden.registro" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/orden/registro" :active="namePath==='orden_registro'">Registrar orden</b-list-group-item>
    <b-list-group-item  v-if="user.permisos_modulos.orden.pendientes" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/orden/pendientes" :active="namePath==='orden_pendientes'">Pendientes</b-list-group-item>
      <b-list-group-item  v-if="user.permisos_modulos.orden.antiguos" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/orden/antiguos" :active="namePath==='orden_antiguos'">Registrar anteriores</b-list-group-item>
    </b-list-group> 
     
    <span v-if="user.permisos_modulos.orden.garantias || user.permisos_modulos.orden.pendgarantias" class="aside-title-span" :class="{'text-header' : namePath.includes('garantias')}"><b-icon style="vertical-align: text-bottom;" icon="documents" font-scale="1.1" aria-hidden="true"></b-icon> GARANTIAS</span>
    <b-list-group>
      <b-list-group-item  v-if="user.permisos_modulos.orden.garantias" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/orden/garantias" :active="namePath==='orden_garantias'">Orden Garantia</b-list-group-item> 
      <b-list-group-item  v-if="user.permisos_modulos.orden.pendgarantias" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/orden/pendgarantias" :active="namePath==='orden_pendgarantias'">Garantias pendientes</b-list-group-item> 
    </b-list-group> 

    <span  v-if="user.permisos_modulos.proveedor.lente || user.permisos_modulos.proveedor.montura" class="aside-title-span" :class="{'text-header' : namePath.includes('proveedor_')}"><b-icon  style="vertical-align: text-bottom;"  font-scale="1.3" icon="inbox-fill" aria-hidden="true"></b-icon> PROVEEDORES</span>
    <b-list-group>

      <b-list-group-item  v-if="user.permisos_modulos.proveedor.lente" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/proveedor/lentes"   :active="namePath==='proveedor_lente'">Lentes</b-list-group-item>

      <b-list-group-item  v-if="user.permisos_modulos.proveedor.montura" style="border-right:none;padding: 0.4rem 1.25rem;" href="#/proveedor/monturas" :active="namePath==='proveedor_montura'">Monturas</b-list-group-item>

    </b-list-group> 

    <span v-if="user.permisos_modulos.admin.usuarios" class="aside-title-span" :class="{'text-header' : namePath.includes('admin_')}"><b-icon  style="vertical-align: text-bottom;"  font-scale="1.3" icon="person-fill" aria-hidden="true"></b-icon>ADMIN</span>
    <b-list-group>

      <b-list-group-item  v-if="user.permisos_modulos.admin.usuarios"  style="border-right:none;padding: 0.4rem 1.25rem;" href="#/admin/usuarios"   :active="namePath==='admin_usuarios'">Usuarios</b-list-group-item>
    </b-list-group> 
  </div>
</template>
<script>
export default {
  name: "blank-layout"
};
</script>
<style>
.div-aside {
  background: white;
  position: fixed;
  width: 200px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  overflow: auto;
  padding-bottom: 65px;
}
.aside-btn{
  border-radius: 0;
  background: #003152;
  border: none;
}
.aside-btn:focus, .aside-btn:hover, .aside-btn:not(:disabled):not(.disabled):active{
  background: #003152;
  border: none;
  box-shadow: none !important;
}
.collapse .list-group-item{
  cursor:pointer;
  border-radius: 0
}
.list-group-item:first-child{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.list-group-item:last-child{
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.list-group-item.active {
    background-color: #006FE6;
    border-color: #006FE6;
}
.aside-title-span.text-header{
 color: #006FE6 
}
.aside-title-span{
  background:rgba(0, 0, 0, 0.03);
  padding: 9px;
  display: block;
  color: #6c757d;
  font-weight: bold;
}
</style>
